import * as React from 'react'
import './CircularProgressBar.scss'

import { MAX_PERCENTAGE, MIN_PERCENTAGE } from '../constants'

interface IProps {
  fillColor?: string
  bgColor?: string
  diameter: number
  percentage: number
  strokeWidth: number
}

interface State {
  percentage: number
}

class CircularProgressBar extends React.PureComponent<IProps, State> {
  public static props: IProps = {
    fillColor: '#000',
    bgColor: '#F6F5F3',
    diameter: 100,
    percentage: 0,
    strokeWidth: 14,
  }

  public _getPathRadius() {
    return this.props.diameter / 2 - this.props.strokeWidth / 2
  }

  public _getPathDescription() {
    const radius = this._getPathRadius()
    const rotation = 0
    return `
      M ${this.props.diameter / 2}, ${this.props.diameter / 2}
      m 0,-${radius}
      a ${radius}, ${radius} ${rotation} 1 1 0, ${2 * radius}
      a ${radius}, ${radius} ${rotation} 1 1 0, -${2 * radius}
    `
  }

  public _getPathStyles() {
    const diameter = Math.PI * 2 * this._getPathRadius()
    const truncatedPercentage = Math.min(
      Math.max(this.props.percentage, MIN_PERCENTAGE),
      MAX_PERCENTAGE
    )
    const dashOffset = (100 - truncatedPercentage) / 100 * diameter

    return {
      strokeDasharray: `${diameter}px ${diameter}px`,
      strokeDashoffset: `${dashOffset}px`,
    }
  }

  public render() {
    const { strokeWidth } = this.props

    const pathDescription = this._getPathDescription()

    return (
      <svg
        className="cpb"
        viewBox={`0 0 ${this.props.diameter} ${this.props.diameter}`}
        style={{
          width: `${this.props.diameter}px`,
        }}
      >
        <path
          className="cpb__trail"
          d={pathDescription}
          strokeWidth={strokeWidth}
          fillOpacity={0}
          style={{
            stroke: this.props.bgColor,
          }}
        />

        <path
          className="cpb__path"
          d={pathDescription}
          strokeWidth={strokeWidth}
          fillOpacity={0}
          style={{
            stroke: this.props.fillColor,
            ...this._getPathStyles(),
          }}
        />
      </svg>
    )
  }
}

export default CircularProgressBar



// WEBPACK FOOTER //
// ./src/components/CircularProgressBar.tsx